module.exports = __webpack_public_path__ + "media/images/ui-images/image-responsive-8bd624f9ef74b9504ce056957fe05d57.jpg";